const getlocalStorageValue = keyArray => {
  let keyReturnObject = {}
  keyArray.map((keyName,index) => {
    keyReturnObject[keyName]=localStorage.getItem(keyName);
  });
  return keyReturnObject;
}

export { getlocalStorageValue }